import dayjs from 'dayjs'

const formatDate = (dateString: string): string => {
  if (!dateString) {
    return ''
  }

  const [datePart] = dateString.split(' ')

  const [year, month, day] = datePart.split('-')

  const formattedDate = `${day}/ ${month}/ ${year}`

  return formattedDate
}

const onShowExpirationDate = (date: string | null) => {
  if (date) {
    return dayjs(date).format('DD/MM/YYYY - HH:mm:ss')
  }

  return ''
}

const addDaysToDate = (days: number): string => {
  let date = new Date()
  date.setDate(date.getDate() + days)

  let day: number | string = date.getDate()
  let month: number | string = date.getMonth() + 1
  const year: number = date.getFullYear()

  if (day < 10) day = '0' + day
  if (month < 10) month = '0' + month

  return `${day}/${month}/${year}`
}

const getLastMondayAt16 = (): String => {
  const today = dayjs()
  const dayOfWeek = today.day()
  const daysSinceMonday = (dayOfWeek + 6) % 7

  const lastMonday = today.subtract(daysSinceMonday, 'day').set('hour', 19).set('minute', 0).set('second', 0)

  return lastMonday.format('DD/MM/YYYY HH:mm')
}

const getLastMondayAt16Date = (): Date => {
  const today = dayjs()
  const dayOfWeek = today.day()
  const daysSinceMonday = (dayOfWeek + 6) % 7

  const lastMonday = today.subtract(daysSinceMonday, 'day').set('hour', 19).set('minute', 0).set('second', 0)

  return lastMonday.toDate()
}

const getNextMondayAt16 = (): string => {
  const today = dayjs()
  const dayOfWeek = today.day()
  const daysUntilMonday = (8 - dayOfWeek) % 7 || 7

  const nextMonday = today.add(daysUntilMonday, 'day').set('hour', 16).set('minute', 0).set('second', 0)

  return nextMonday.format('DD/MM/YYYY HH:mm')
}

const getNextMondayAt16Date = (): Date => {
  const today = dayjs()
  const dayOfWeek = today.day()
  const daysUntilMonday = (8 - dayOfWeek) % 7 || 7

  const nextMonday = today.add(daysUntilMonday, 'day').set('hour', 16).set('minute', 0).set('second', 0)

  return nextMonday.toDate()
}

const getDate31DaysAgo = (): Date => {
  const today = dayjs()
  const date31DaysAgo = today.subtract(31, 'day').set('hour', 0).set('minute', 0).set('second', 0)

  return date31DaysAgo.toDate()
}

export {
  addDaysToDate,
  formatDate,
  getDate31DaysAgo,
  getLastMondayAt16,
  getLastMondayAt16Date,
  getNextMondayAt16,
  getNextMondayAt16Date,
  onShowExpirationDate,
}
